
import { prop } from 'ramda'


import type { AdditionalSettingsType, PostParams } from 'app/dataTypes/dishes/additionalSettings'


import type { Request } from '../../../index'

/**
 * Создание / редактирование блюда
 */

type ApiParams = {
  school_id: number,
  item_id: number, //id продукции
  settings: {
    disable_for_terminal_guest_sales: boolean  // Не продавать гостям в терминале самообслуживания
  }
}

export const convertParams = (params: PostParams): [ApiParams, null] => {
  const { orgId, dishId, settings } = params
  return [{
    school_id: parseInt(orgId, 10),
    item_id: dishId,
    settings: {
      disable_for_terminal_guest_sales: settings.disableForTerminalGuestSales
    }
  }, null]
}

type ApiResult = {
  result: 'success'
  settings: {
    disable_for_terminal_guest_sales: boolean  // Не продавать гостям в терминале самообслуживания
  }
}

export const convertResult = (data: ApiResult): AdditionalSettingsType => {
  const items = prop('settings', data) || {}
  return ({
    disableForTerminalGuestSales: items.disable_for_terminal_guest_sales
  })
}
export const POST_ADDITIONAL_SETTINGS: Request<PostParams, AdditionalSettingsType, void> = [
  'food/items/additional_settings',
  'post',
  ['data'],
]
